import React from 'react';
import AdContainer from '@gik/ads/components/AdContainer';
import ZonePool from '@gik/ads/ZonePool';
import WordPressAd from '@gik/ads/components/WordPressAd';
import FallbackAd from '@gik/ads/components/FallbackAd';
import ArticleAdvertising from '@gik/blog/models/ArticleAdvertising';
import AdGlare from '@gik/ads/components/AdGlare';
import { Breakpoint, useBreakpoint } from '@gik/core/hooks/hooks/BreakpointHooks';

const VerticalAd = 'vertical';
const HorizontalAd = 'horizontal';

export type AdType = typeof VerticalAd | typeof HorizontalAd;

interface AdProps {
  adType?: AdType;
  className?: string;
  override?: ArticleAdvertising;
  zone: string | ZonePool;
  mobileZone?: string | ZonePool;
}

export const adGlareGlobalKeyValueTargetKeyName = 'adglare_kv_taxonomyname';

export function setKeyValuePair(keyValuePair: string) {
  if (keyValuePair && !window[adGlareGlobalKeyValueTargetKeyName]) {
    window[adGlareGlobalKeyValueTargetKeyName] = keyValuePair.toLowerCase().replace(' ', '_').replace('/', '_');
  }
}

export function clearKeyValuePair() {
  delete window[adGlareGlobalKeyValueTargetKeyName];
}

export default function Ad({ adType = 'horizontal', className, override, zone, mobileZone }: AdProps) {
  const isMdDown = useBreakpoint(Breakpoint.MD_DOWN);

  const isAdFromWordPress = function (): boolean {
    return !!override;
  };

  const getOverrideImage = function () {
    return isMdDown
      ? override.mobileMediumRectangle
      : adType === VerticalAd
      ? override.desktopSkyscraper
      : override.desktopLeaderboard;
  };

  return (
    <AdContainer adType={adType} className={className}>
      {isAdFromWordPress() ? (
        <WordPressAd link={override?.link} imageUrl={getOverrideImage()?.url} />
      ) : (
        <AdGlare zone={isMdDown ? mobileZone : zone} fallbackBackEl={<FallbackAd />} />
      )}
    </AdContainer>
  );
}
